<template>
  <tr v-if="attribute">
    <th scope="row" class="pr-1 align-top text-nowrap">
      {{ displayName(attribute) }}
    </th>
    <td>
      <template v-if="dataContainsUri">
        <div
          v-for="(item, index) in attribute.value"
          :key="`${index}-${displayName(item)}`"
        >
          <a
            v-if="item.uri && item.uri.length"
            :href="item.uri"
            target="_blank"
            class="text-break mr-2 mb-2"
          >
            {{ displayName(item) }}
          </a>
          <span v-else>{{ displayName(item) }}</span>
        </div>
      </template>
      <template v-else-if="dataContainsStringArray">
          {{ attribute.value[0].join(", ") }} 
      </template>
      <template v-else>
        <p
          class="text-break mr-2 mb-2"
          v-for="value of attribute.value"
          :key="value"
        >
          {{ value }}
        </p>
      </template>
    </td>
  </tr>
</template>

<script>
export default {
  props: {
    attribute: {
      type: Object,
    },
  },
  computed: {
    dataContainsUri() {
      if (
        this.attribute.value.length &&
        typeof this.attribute.value[0] === "object"
      ) {
        return this.attribute.value.some((item) => item.uri);
      } else {
        return "";
      }
    },
    dataContainsStringArray() {
      const value = this.attribute.value;

      if (!Array.isArray(value) || value.length === 0) {
        return false;
      }
      
      const firstItem = value[0];

      if (!Array.isArray(firstItem) || firstItem.length === 0) {
        return false;
      }

      return firstItem.every(item => typeof item === 'string');
},
  },
  methods: {
    displayName(item) {
      let display_name = item.label || item.name || item.title || item.id;
      if (Array.isArray(display_name)) {
        display_name = display_name.join(", ")
      }
      return display_name
    },
  },
};
</script>

<style scoped>
.fa-external-link {
  top: 1px;
  position: relative;
}

.fa-external-link:hover {
  cursor: pointer;
}
</style>
